import { ISaveObraChecklistServicoLiberacaoUseCase } from "../../../presentation/useCases/update/save_obra_checklist_servico_liberacao_use_case";
import { ObraChecklistServicoLiberacaoForm } from "../../../presentation/schemas/Obras_checklistarea/obra_checklist_servico_liberacao";
import { IObrasRepository } from "../../repositories/obras_repository";

export class SaveObraChecklistServicoLiberacaoUseCase implements ISaveObraChecklistServicoLiberacaoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(idObraChecklistServico: number, idChecklistServico: number, form: ObraChecklistServicoLiberacaoForm) {
    await this.repository.saveObraChecklistServicoLiberacao(idObraChecklistServico, idChecklistServico, form);
  }
}
